import React, { MouseEventHandler } from 'react';
import {
  StyledOrderRecapConfirmModalButtonContainer,
  StyledOrderRecapConfirmModalDescription,
  StyledOrderRecapConfirmModalSpinnerContainer,
  StyledOrderRecapConfirmModalTitle
} from './OrderRecapConfirmModalStyles';
import { changeStep, selectOrderState } from '../../reducer/orderSlice';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';

import Button from '@designSystem/Button';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import Icon from '@designSystem/Icon';
import { getOrderErrorMessageAndActionLabel } from '../../utils/OrderHelper';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  IOrderInformationsForm,
  IOrderInformationsOperaBusinessForm,
  Order
} from '@features/order/utils/orderInterfaces';
import { ProductOfferingQualificationItem } from '@features/eligibility/interfaces';

const OrderRecapConfirmModalError = ({
  closeModal,
  infos,
  order
}: {
  closeModal: MouseEventHandler<HTMLButtonElement>;
  infos: IOrderInformationsForm | IOrderInformationsOperaBusinessForm | null;
  order: (Order & ProductOfferingQualificationItem) | null;
}) => {
  const { orderCreationError } = useAppSelector(selectOrderState);
  const errorsAndAction = getOrderErrorMessageAndActionLabel(orderCreationError);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const urlContactParams = new URLSearchParams({
    address: infos?.address ?? '',
    buildingId: infos?.buildingRef ?? '',
    phone: infos?.phoneContact1 ?? '',
    email: infos?.email ?? '',
    comment: infos?.comments ?? '',
    product: order?.productOrderItem[0]?.product?.productOffering?.description ?? '',
    orderReference: order?.externalReference ?? ''
  });

  return (
    <>
      <StyledOrderRecapConfirmModalSpinnerContainer>
        <Icon variant="red" round>
          <ExclamationTriangleFill />
        </Icon>
      </StyledOrderRecapConfirmModalSpinnerContainer>
      <StyledOrderRecapConfirmModalTitle>
        {t('errorMessages.orderCreationFailed', 'Order creation has failed')}
      </StyledOrderRecapConfirmModalTitle>
      <StyledOrderRecapConfirmModalDescription>
        {errorsAndAction.errors.length ? (
          errorsAndAction.errors.map((error, index) => <span key={index}>{error}</span>)
        ) : (
          <>
            {t(
              'errorMessages.tryAgain',
              'Veuillez réessayer ultérieurement. Si le problème persiste, cliquez ci-dessous pour nous contacter'
            )}
          </>
        )}
      </StyledOrderRecapConfirmModalDescription>

      <StyledOrderRecapConfirmModalButtonContainer>
        <Button
          autoFocus
          design="white"
          style={{ width: '100%' }}
          onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            if (errorsAndAction.redirectToStep)
              dispatch(changeStep(errorsAndAction.redirectToStep));
            return closeModal(e);
          }}
        >
          {errorsAndAction.action}
        </Button>
        <Button
          autoFocus
          design="plain"
          style={{ width: '100%' }}
          onClick={() => {
            navigate(`/contact?${urlContactParams.toString()}`);
          }}
        >
          Contacter le support
        </Button>
      </StyledOrderRecapConfirmModalButtonContainer>
    </>
  );
};

export default OrderRecapConfirmModalError;
